import React from "react";
import ConfirmationStep from "./ConfirmationStep";
import EmailEntryStep from "./EmailEntryStep";
import StartingStep from "./StartingStep";
const Steps = ({
  fields,
  rendering,
  stepNumber,
  proceedToNextStep
}) => {
  switch (stepNumber) {
    case 2:
      {
        return /*#__PURE__*/React.createElement(EmailEntryStep, {
          fields: fields,
          rendering: rendering,
          proceedToNextStep: proceedToNextStep
        });
      }
    case 3:
      {
        return /*#__PURE__*/React.createElement(ConfirmationStep, {
          fields: fields
        });
      }
    default:
      {
        return /*#__PURE__*/React.createElement(StartingStep, {
          fields: fields,
          proceedToNextStep: proceedToNextStep
        });
      }
  }
};
export default Steps;